import { AdminHouseAccountProvider } from './adminHouseAccountContext';
import { LeadsExclusionProvider } from './adminLeadsExclusionContext';
import { AssignToHouseProvider } from './assignToHouseContext';
import { CustomerOutreachProvider } from './customerOutreachContext';
import { CustomerPricesProvider } from './customerPricesContext';
import { FranchisedBrandsProvider } from './franchisedBrands';
import { FranchiseQueueProvider } from './franchiseQueueContext';
import { FreightProvider } from './freightContext';
import { HelpDeskTrackerProvider } from './helpdeskTrackerContext';
import { HouseAccountProvider } from './houseAccountContext';
import { InventoryEngineProvider } from './inventoryEngienContext';
import { KeyForAttachProvider } from './keyForAttachContext';
import { LinkedCleanserProvider } from './linkedCleanserContext';
import { ManagementReportProvider } from './mangementReportContext1';
import { MassMailProvider } from './massMailContext';
import { MpnQueueProvider } from './mpnQueueContext';
import { MyPastEmailsProvider } from './myPastEmails';
import { RfqQueueProvider } from './rfqQueueContext';

const contextProviders = [
	MpnQueueProvider,
	FreightProvider,
	KeyForAttachProvider,
	AdminHouseAccountProvider,
	HouseAccountProvider,
	AssignToHouseProvider,
	ManagementReportProvider,
	CustomerOutreachProvider,
	LinkedCleanserProvider,
	CustomerPricesProvider,
	MassMailProvider,
	HelpDeskTrackerProvider,
	FranchisedBrandsProvider,
	LeadsExclusionProvider,
	MyPastEmailsProvider,
	RfqQueueProvider,
	FranchiseQueueProvider,
	InventoryEngineProvider,
];

export default contextProviders;
